import React from "react";
import { useNavigate } from "react-router-dom";
import { routes, contactInfo } from "../data/mock";
import { Button } from "./ui/button";
import { ArrowRight, Check } from "lucide-react";
import { Reveal, ChapterTag } from "../lib/motion";

export const TwoRoutes = () => {
  const navigate = useNavigate();
  const handleAction = (card) => {
    if (card.action === "diagnostic") navigate("/diagnostic");
    else window.open(contactInfo.bookingUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="routes" data-testid="routes-section" className="py-24 sm:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="02" label="Two ways in" />
          <h2 className="mt-6 font-display font-semibold text-stone-900 tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
            {routes.heading}
          </h2>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          {routes.cards.map((card, i) => (
            <Reveal
              key={i}
              delay={i * 0.12}
              className={`relative rounded-3xl p-8 sm:p-10 flex flex-col overflow-hidden ${
                i === 0
                  ? "bg-white border border-stone-200"
                  : "bg-[#032e2d] text-teal-50 grain"
              }`}
              data-testid={`route-card-${i}`}
            >
              <span className={`font-display  text-6xl leading-none ${i === 0 ? "text-brand-200" : "text-teal-200/20"}`}>
                {i === 0 ? "a." : "b."}
              </span>
              <h3 className={`mt-6 font-display font-semibold text-2xl sm:text-3xl leading-tight ${i === 0 ? "text-stone-900" : "text-white"}`}>
                {card.title}
              </h3>
              <p className={`mt-4 leading-relaxed text-base ${i === 0 ? "text-stone-600" : "text-teal-100/80"}`}>
                {card.copy}
              </p>

              {card.examples.length > 0 && (
                <div className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-2">
                  {card.examples.map((ex, j) => (
                    <div key={j} className="flex items-start gap-2">
                      <Check className="w-4 h-4 mt-0.5 text-brand-600 flex-shrink-0" />
                      <span className="text-sm text-stone-600">{ex}</span>
                    </div>
                  ))}
                </div>
              )}

              <div className="mt-8 pt-2 mt-auto">
                <Button
                  onClick={() => handleAction(card)}
                  data-testid={`route-cta-${i}`}
                  className={`rounded-full h-12 px-7 text-sm font-medium transition-all duration-300 hover:-translate-y-0.5 ${
                    i === 0
                      ? "bg-stone-900 hover:bg-brand-700 text-[#FAF7F2]"
                      : "bg-teal-50 hover:bg-white text-[#032e2d]"
                  }`}
                >
                  {card.cta}
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
